import React from 'react';
import { Field } from 'formik';
import { v4 as uuid } from 'uuid';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/opacity.css';
import tablet2Icon from 'assets/images/tablet2.png';

const RadioButtons = (props) => {
  const { label, gif, name, options, isRequired, handleNext, ...rest } = { ...props };
  const { control } = { ...rest };
  const isSelectImage = control === 'select-image';
  
  const mapOptions = options.map((item) => {
    if (item.value) {
      return item;
    }
    return { value: item, label: item };
  });
  return (
    <div className="question">
      {isSelectImage ? (
        <>
          <div className="question__icon">
            <img src={tablet2Icon} alt="tablet-icon" />
          </div>
          <div className="question__validation">
            <label htmlFor={name}>{label}</label>
          </div>
          <div className="question__imagepicker-container">
            <Field id={name} name={name} {...rest}>
              {({ field }) =>
                (gif || []).map((imageUrl, index) => {
                  const value = index.toString();
                  const isChecked = field.value === value;
                  return (
                    <label
                      key={value}
                      className={`radio radio--${isChecked ? 'checked' : ''} question__imagepicker__wrapper`}
                    >
                      <div className="question__imagepicker-content">
                        <div className="question__imagepicker-number">
                          <span>{index + 1}</span>
                        </div>
                        <div className="question__imagepicker-image">
                          <LazyLoadImage
                            src={imageUrl}
                            alt={`Opción ${index + 1}`}
                            effect="opacity"
                          />
                        </div>
                      </div>
                      <input
                        type="radio"
                        id={`option-${index}`}
                        {...field}
                        value={value}
                        checked={isChecked}
                        onClick={() => setTimeout(handleNext, 300)}
                      />
                    </label>
                  );
                })
              }
            </Field>
          </div>
        </>
      ) : (
        <>
          <div className="question__icon">
            <img src={tablet2Icon} alt="tablet-icon" />
          </div>
          <div className="question__validation">
            <label htmlFor={name}>{label}</label>
          </div>
          {!!gif && (
            <div className="question__gif">
              <LazyLoadImage effect="opacity" src={gif} alt="this is a Gif" />
            </div>
          )}
          <div className="question__multiple-options">
            <Field id={name} name={name} {...rest}>
              {({ field }) =>
            mapOptions.map((option) => (
              <label key={uuid()} className={`radio radio--${field.value === option.label ? 'checked' : ''}`}>
                  {option.label}
                <input
                  type="radio"
                  id={option.label}
                  {...field}
                  value={option.label}
                  checked={field.value === option.label}
                  onClick={() => setTimeout(handleNext, 300)}
                  />
                </label>
            ))
              }
            </Field>
          </div>
        </>
      )}
    </div>
  );
};

export default RadioButtons;
